import { io, Socket } from 'socket.io-client';
import type { OutletStatusInfo } from '@photobooth/types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export interface WebSocketEvents {
  'outlet:status': (status: OutletStatusInfo) => void;
  'outlet:alert': (alert: unknown) => void;
}

let socket: Socket | null = null;

export function connectWebSocket(): Socket {
  if (socket?.connected) {
    return socket;
  }

  const token = localStorage.getItem('auth_token');
  
  socket = io(API_URL, {
    auth: { token },
    autoConnect: true,
  });

  socket.on('connect', () => {
    console.log('WebSocket connected');
  });

  socket.on('disconnect', () => {
    console.log('WebSocket disconnected');
  });

  socket.on('connect_error', (error) => {
    console.error('WebSocket connection error:', error);
  });

  return socket;
}

export function disconnectWebSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket(): Socket | null {
  return socket;
}
